import api from './client'

export interface Lead {
  id: string
  companyId: string
  firstName: string
  lastName: string
  email: string | null
  phone: string | null
  organization: string | null
  organizationId: string | null
  status: string
  source: string | null
  assignedTo: string | null
  assignedUser?: { id: string; firstName: string; lastName: string }
  notes: string | null
  customFields: Record<string, unknown>
  slaDeadline: string | null
  slaBreahed: boolean
  convertedToDealId: string | null
  createdAt: string
  updatedAt: string
}

export interface LeadListParams {
  page?: number
  limit?: number
  sortField?: string
  sortOrder?: 'ASC' | 'DESC'
  filters?: string
  viewId?: string
  search?: string
}

export interface PaginatedResponse<T> {
  data: T[]
  meta: { page: number; limit: number; total: number; totalPages: number }
}

export interface LeadStatusCount {
  status: string
  count: number
}

export const leadsApi = {
  list: (companyId: string, params: LeadListParams = {}) =>
    api.get<PaginatedResponse<Lead>>(`/companies/${companyId}/leads`, { params }),
  get: (companyId: string, id: string) =>
    api.get<Lead>(`/companies/${companyId}/leads/${id}`),
  create: (companyId: string, dto: Partial<Lead>) =>
    api.post<Lead>(`/companies/${companyId}/leads`, dto),
  update: (companyId: string, id: string, dto: Partial<Lead> & { skipActivity?: boolean }, signal?: AbortSignal) =>
    api.patch<Lead>(`/companies/${companyId}/leads/${id}`, dto, signal ? { signal } : undefined),
  remove: (companyId: string, id: string) =>
    api.delete(`/companies/${companyId}/leads/${id}`),
  convert: (companyId: string, id: string, dto: Record<string, unknown>) =>
    api.post(`/companies/${companyId}/leads/${id}/convert`, dto),
  import: (companyId: string, file: File) => {
    const form = new FormData()
    form.append('file', file)
    return api.post(`/companies/${companyId}/leads/import`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  export: (companyId: string, params: LeadListParams = {}) =>
    api.get(`/companies/${companyId}/leads/export`, { params, responseType: 'blob' }),
  statusCounts: (companyId: string) =>
    api.get<LeadStatusCount[]>(`/companies/${companyId}/leads/status-counts`),
  prevLead: (companyId: string, id: string, status?: string) =>
    api.get<{ id: string | null }>(`/companies/${companyId}/leads/${id}/prev`, { params: status ? { status } : undefined }),
  nextLead: (companyId: string, id: string, status?: string) =>
    api.get<{ id: string | null }>(`/companies/${companyId}/leads/${id}/next`, { params: status ? { status } : undefined }),
  rt: (companyId: string, id: string) =>
    api.get<{ v: string }>(`/companies/${companyId}/leads/${id}/rt`),
}
